var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.configDone)?_c('router-view'):_vm._e(),(_vm.initDone)?_c('qr-code'):_vm._e(),_c('snapShot',{ref:"snapShot"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }